import { Button } from '@brightdrop/bd-ui';
import { TranslatedLabel } from '@gm-commercial/translations';
import type { BannerAction } from '../../models/selectedRowActionsBanner.model';

export const renderLabel = (action: BannerAction) => (
  <TranslatedLabel
    dataTestId={action.key}
    translationKey={action.translationKey ?? ''}
    typographyVariant="small_body_medium"
    variables={action.variables}
  />
);

export const renderButtonAction = (
  action: BannerAction,
  classes: Record<string, string>
) => {
  const baseClassName =
    action.type === 'iconText' || action.type === 'labelAction'
      ? classes.bannerActionContent
      : classes.bannerActionLink;

  // Apply custom icon colors class if specified
  const className = action.useCustomIconColors
    ? `${baseClassName} custom-icon-colors`
    : baseClassName;

  return (
    <Button
      data-testid={action.key}
      variant="button-link"
      onClick={action.onClick}
      className={className}
      startIcon={action?.icon}
      disabled={action.disabled}
      isLoading={action.isLoading}
    >
      <TranslatedLabel
        translationKey={action.translationKey ?? ''}
        typographyVariant="small_body_medium"
        variables={action.variables}
      />
    </Button>
  );
};
